import React, { useState, useMemo, useEffect } from 'react';
import { VariablePanel } from './VariablePanel';
import { MathsFactory } from './MathsFactory';
import 'mafs/core.css';
import 'mafs/font.css';

export const VisualisationWidget = ({ data, hideExplanation = false }) => {
    const { visualisation } = data;

    // 1. Initialize Variables
    const initialVariables = useMemo(() => {
        const vars = {};
        if (visualisation.variables) {
            Object.entries(visualisation.variables).forEach(([key, def]) => {
                vars[key] = def.defaultValue;
            });
        }
        return vars;
    }, [visualisation.variables]);

    const [variableState, setVariableState] = useState(initialVariables);

    // Reset state when data changes (e.g. new question loaded)
    useEffect(() => {
        setVariableState(initialVariables);
    }, [initialVariables]);

    const hasVariables = visualisation.variables && Object.keys(visualisation.variables).length > 0;

    return (
        <div className="ch-widget-container flexRow flexWrap gap-large padding--m border-all--s border-radius--m bg-white">

            {/* Visualisation Area */}
            <div className="flex1 min-height-400 ch-visualization-area">

                {/* All widgets are now Self-Contained.
                   They manage their own Mafs context, SVG, or DOM structure.
                */}
                <MathsFactory
                    type={visualisation.type}
                    config={visualisation.config}
                    variables={variableState}
                />

                {!hideExplanation && visualisation.explanation && (
                    <div className="margin-t--m padding--m bg-light-gray border-radius--s">
                        <p className="text-center text-muted ch-italic" style={{ margin: 0 }}>
                            {visualisation.explanation}
                        </p>
                    </div>
                )}
            </div>

            {/* Variable Controls Sidebar */}
            {hasVariables && (
                <div className="ch-variable-sidebar padding--m bg-light-gray border-all--s border-radius--s" style={{ minWidth: '250px' }}>
                    <h4 className="ch-label uppercase text-muted margin-b--m font-bold">
                        Controls
                    </h4>

                    <VariablePanel
                        definitions={visualisation.variables}
                        currentState={variableState}
                        onChange={setVariableState}
                    />
                </div>
            )}
        </div>
    );
};